import { FC } from 'react';
import cls from 'classnames';
// import { FormattedMessage } from "react-intl";
import styles from './index.module.scss';

interface IProps {
  coin?: string;
  chain?: string;
  chainIcon?: string;
  className?: string;
  type?: 'mobile' | 'pc';
  iconUrl?: string;
  size?: 'large' | 'small';
}

export const getColor = (coin = '') => {
  const colors = ['#9747FF', '#28C6B6', '#FF9C2E', '#5BD45F'];
  let coinNameCount = 0;
  for (let i = 0; i < coin?.length; i++) {
    coinNameCount += coin.charCodeAt(i);
  }
  return colors[coinNameCount % colors.length];
};

export const getShortName = (coin: string) => {
  return coin?.slice(0, 2).toUpperCase();
};

const btcIconBlack =
  'https://fh-static.bycsi.com/BTC-DARK-ef45fd7b0cfdb31628ab646d73b24044.svg';

// 'https://app.bybit.com/deadpool-test/image-29627385b7854445a64f535a040981c2.png'

export const CoinCard: FC<IProps> = ({
  type = 'pc',
  coin = 'ORDI',
  chain = 'BTC',
  chainIcon = btcIconBlack,
  className,
  iconUrl,
  size,
}) => {
  const shortName = getShortName(coin);
  const color = getColor(shortName);
  return (
    <div
      className={cls(styles.coinCard, className, {
        [styles.large]: size === 'large',
      })}
    >
      {iconUrl ? (
        <img className={styles.icon} src={iconUrl} alt="img" />
      ) : (
        <div className={styles.icon} style={{ backgroundColor: color }}>
          {shortName}
        </div>
      )}
      {type === 'pc' && (
        <div className={styles.content}>
          <div className={styles.title}>{coin}</div>
          {chain && chainIcon ? (
            <div className={styles.coin}>
              <img className={styles.coinIcon} src={chainIcon} alt="img" />
              <div className={styles.coinName}>BTC</div>
            </div>
          ) : null}
        </div>
      )}
    </div>
  );
};
